import { useExperimentalFlag } from '../hooks/useExperimentalFlag'
import { lazy, Suspense, useEffect } from 'react'
import './Dashboard.css'

// The onboarding chat is the dashboard's entire surface but belongs to no other page, so loading it
// as a deferred chunk keeps its copy and chat modules out of the eager entry bundle
// (QA bug bug-mtxbj0h6-u58d).
const OnboardingChat = lazy(() => import('../components/OnboardingChat'))


export default function Dashboard() {
  const { loaded } = useExperimentalFlag('continuous_testing')
  useEffect(() => {
    document.title = 'Replay QA'
  }, [])

  // Onboarding is a guided chat that starts from a URL and ends at createProject → the project
  // overview.
  return (
    <div className="dashboard" data-testid="dashboard-page">
      <Suspense fallback={null}>
        {loaded ? <OnboardingChat /> : <p role="status">Loading setup…</p>}
      </Suspense>
    </div>
  )
}
